import React from "react";
import "./Contatos.css";
import { FaHome, FaPhoneAlt, FaWhatsapp, FaUserMd, FaClipboardList } from "react-icons/fa";
import clinicaConfig from "../../clinicaConfig.js";

const Recolha = () => {
  return (
    <div className="contatos-section">
      <div className="contatos-header">
        <h1>Como Podemos Ajudá-lo?</h1>
        <p>Estamos prontos para atender você da melhor forma possível</p>
      </div>

      <div className="contatos-grid">
        <div className="contato-card">
          <div className="contato-icon-wrapper">
            <FaHome />
          </div>
          <h3>Coleta Domiciliar</h3>
          <p>Marque sua coleta domiciliar no conforto de sua casa</p>
          <a
            className="contato-btn"
            href={`https://wa.me/${clinicaConfig.whatsapp}?text=Olá,%20eu%20gostaria%20de%20agendar%20a%20minha%20coleta%20domiciliar!`}
            target="_blank"
            rel="noreferrer"
          >
            Agendar Coleta
          </a>
        </div>

        <div className="contato-card">
          <div className="contato-icon-wrapper">
            <FaPhoneAlt />
          </div>
          <h3>Fale Conosco</h3>
          <div className="contato-info">
            <p><strong>WhatsApp:</strong> {clinicaConfig.whatsappFormatado}</p>
            <p><strong>Telefone:</strong> {clinicaConfig.whatsappFormatado}</p>
          </div>
          <a className="contato-btn" href={`tel:+${clinicaConfig.whatsapp}`}>
            Ligar Agora
          </a>
        </div>

        <div className="contato-card">
          <div className="contato-icon-wrapper">
            <FaWhatsapp />
          </div>
          <h3>Solicite um Orçamento</h3>
          <p>Tem uma solicitação médica? Envie pelo WhatsApp e receba um orçamento rápido</p>
          <a
            className="contato-btn"
            href={`https://wa.me/${clinicaConfig.whatsapp}?text=Olá,%20estou%20encaminhando%20minha%20solicitação%20médica.%20Poderia,%20por%20favor,%20me%20informar%20o%20valor%20dos%20exames?`}
            target="_blank"
            rel="noreferrer"
          >
            Enviar Solicitação
          </a>
        </div>

        <div className="contato-card">
          <div className="contato-icon-wrapper">
            <FaUserMd />
          </div>
          <h3>Nossos Profissionais</h3>
          <p>Conheça nossa equipe de especialistas e encontre o profissional ideal para você</p>
          <a
            className="contato-btn"
            href={'/todos-medicos'}
            rel="noreferrer"
          >
            Ver Profissionais
          </a>
        </div>

        <div className="contato-card">
          <div className="contato-icon-wrapper">
            <FaClipboardList />
          </div>
          <h3>Resultados de Exames</h3>
          <p>Acesse seus resultados de forma rápida e segura através do nosso portal</p>
          <a
            className="contato-btn"
            href={'/resultados-exames'}
            rel="noreferrer"
          >
            Acessar Resultados
          </a>
        </div>
      </div>
    </div>
  );
};

export default Recolha;
